import { CustomElement } from '@aurelia/runtime-html';
export const name = "confirm-dialog";
export const template = "<div if.bind=\"visible\" class=\"dialog-layer\">\r\n  <div class=\"modal-backdrop modal-backdrop--dialog\"></div>\r\n  <div class=\"modal modal--dialog\" role=\"dialog\" aria-modal=\"true\">\r\n    <div class=\"modal__header\">\r\n      <h2>${title}</h2>\r\n    </div>\r\n    <div class=\"modal__body\">\r\n      <p class=\"dialog__message\">${message}</p>\r\n    </div>\r\n    <div class=\"modal__footer\">\r\n      <button class=\"btn btn--secondary\" if.bind=\"!isAlert\" click.trigger=\"cancel()\" t=\"common.cancel\"></button>\r\n      <button class=\"btn btn--primary\" click.trigger=\"ok()\" t=\"common.ok\"></button>\r\n    </div>\r\n  </div>\r\n</div>\r\n";
export default template;
export const dependencies = [  ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
